import Vue from 'vue'
import "./filters"

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n zh-CN
import VCharts from 'v-charts'
import { customDisabledDate } from './utils/date';
import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control

Vue.use(ElementUI, { locale })
Vue.use(VCharts)
// Global mixin to add the disabledDate method to all components
Vue.mixin({
  methods: {
    customDisabledDate,
  },
});

// Register a global custom directive called 'no-space'
Vue.directive('no-space', {
  bind(el) {
    // Add event listener to the element
    el.addEventListener('keydown', (event) => {
      if (event.keyCode === 32 || event.key === ' ') {
        event.preventDefault();  // Prevent space key
      }
    });
  }
});

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app');
